import React from "react";
import Header from "src/Component/content-component/Header";
import ContentContainer from "src/Component/grid-component/ContentContainer";
import ParaData from "src/Component/content-component/ParaData";
import MainContainer from "src/Component/grid-component/MainContainer";
import ImageContainer from "src/Component/grid-component/ImageContainer";

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
const study_in_india = imageBaseUrl + "International-Relation/University/indian_culture.jpg";

const StudyInIndia = () => {
  return (
    <>
    <MainContainer
      com1={<ImageContainer img={study_in_india} />}
      com2={
        <ContentContainer
          Header={<Header content={"Study In India"} color="#00999E" />}
          Content={
            <ParaData
              color={"#525560"}
              fontSize={"16px"}
              content={
                <>
                  India is a top study destination with,{" "}
                  <strong>1,100+ universities </strong>and{" "}
                  <strong>42,000+ colleges</strong>, attracting{" "}
                  <strong>50,000+ international students</strong> from{" "}
                  <strong>160+ countries.</strong> Prestigious institutions like
                  <strong> IITs, IIMs, and AIIMS</strong> offer world-class
                  education at <strong> affordable costs</strong> —tuition
                  starts at
                  <strong> $1,000/year,</strong> and living expenses average
                  from <strong> $800/year to $1,500/year.</strong> With a
                  booming economy and strong industry ties, India offers
                  excellent <strong>career opportunities</strong> and global
                  exposure.
                </>
              }
            />
          }
        />
      }
    />
    </>
  );
};

export default StudyInIndia;
